import { render, staticRenderFns } from "./FormRow.vue?vue&type=template&id=64931030"
import script from "./FormRow.vue?vue&type=script&lang=js"
export * from "./FormRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports